import React from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import { MapPin, MapPinModel } from '../models';

interface PinMarkerProps {
  pin: MapPin;
  isSeen: boolean;
  onPinClick: (pin: MapPin) => void;
}

// Pin shows its photo in a circle when available, otherwise the
// type emoji — matching iOS PinAnnotationView (bare emoji + shadow).
// Unseen pins get the pulsing ring (red hazard / green business).
const createPinIcon = (pin: MapPin, isSeen: boolean) => {
  const pinInfo = MapPinModel.getDisplayInfo(pin);
  const degrade = `${pin.reportCount > 5 ? 'transform: scale(0.8); opacity: 0.7;' : ''}
                   ${pin.reportCount > 10 ? 'opacity: 0.5;' : ''}`;

  // iOS PinAnnotationView: system green for business pins, system red otherwise
  const ringColor = pinInfo.isBusiness ? '#34c759' : '#ff3b30';
  const rings = isSeen ? '' : `
    <div class="pin-ring pin-ring-a" style="border-color: ${ringColor};"></div>
    <div class="pin-ring pin-ring-b" style="border-color: ${ringColor}80;"></div>
  `;

  const html = pin.imageURL
    ? `
      <div style="
        width: 44px;
        height: 44px;
        border-radius: 50%;
        border: 2px solid ${pinInfo.color};
        overflow: hidden;
        box-shadow: 0 2px 6px rgba(0,0,0,0.4);
        background: white;
        ${degrade}
      ">
        <img src="${pin.imageURL}" style="width:100%;height:100%;object-fit:cover;display:block;" />
      </div>
    `
    : `
      <div style="
        font-size: 28px;
        line-height: 1;
        text-align: center;
        text-shadow: 0 1px 2px rgba(0,0,0,0.4);
        ${degrade}
      ">
        ${pinInfo.emoji}
      </div>
    `;

  return L.divIcon({
    html: rings + html,
    className: 'custom-pin-icon',
    iconSize: [44, 44],
    iconAnchor: [22, 22],
  });
};

const PinMarker: React.FC<PinMarkerProps> = ({ pin, isSeen, onPinClick }) => {
  return (
    <Marker
      position={[pin.latitude, pin.longitude]}
      icon={createPinIcon(pin, isSeen)}
      eventHandlers={{
        click: () => onPinClick(pin),
      }}
    />
  );
};

export default PinMarker;
